export default "__VITE_ASSET__240104c5__"